import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SliderBox } from '../../../molecules/slider-box';
import { SwitchBox } from '../../../molecules/switch-box';
import { ValueBox } from '../../../molecules/value-box';
import { FormattedValue } from '../../../store/formatted-value';
import { ParentPaper } from '../../../atoms/parent-paper';
import { HelpButton } from '../../../atoms/help-button';

export const SettingsSpBatteryCharge = () => {
  return (
    <ParentPaper>
      <SwitchBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery_charge"
              defaultMessage="Povoleno nabíjení baterie podle spotu"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.battery_charge"
                  defaultMessage="Povoleno nabíjení baterie podle spotu"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.battery_charge.help"
                  defaultMessage="Pokud zvolíte tuto možnost, tak systém naplánuje nabíjení v době nejnižších cen. Bere v potaz aktuální úroveň nabití baterie a její kapacitu. Na základě těchto parametrů zvolí délku nabíjení tak, aby došlo k jejímu nabití za co nejnižší cenu."
                />
              }
            />
          </>
        }
        switchVariableId="SP_BATTERY_CONTROL_CUSTOMER"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery_charge.subtitle"
            defaultMessage="Řízení baterie podle spotu zvýší amortizaci baterie"
          />
        }
        visibility={{
          variableIds: [
            'SP_INSTALL',
            'PV_BATTERY',
            'SP_BATTERY_CONTROL_SERVICE',
            'PV_BATTERY_CONTROL',
          ],
        }}
        fullWidth
      />
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery_strategy"
              defaultMessage="Strategie spotového nabíjení baterie"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.battery_strategy"
                  defaultMessage="Strategie spotového nabíjení baterie"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.battery_strategy.help"
                  defaultMessage="Tímto posuvníkem můžete jednoduše nastavit preferenci využití baterie při spotovém obchodování. Nižší hodnoty (od 20 %) znamenají menší cyklování baterie a tedy méně časté nabíjení/vybíjení za spotové ceny. Vyšší hodnoty (až do 70 %) značí opak."
                />
              }
            />
          </>
        }
        variableId="SP_MIN_SPOT_DIFFERENCE_BATTERY_SOC"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery_strategy_user.subtitle"
            defaultMessage="20 % = Spíše využívat baterii pro FVE. 70 % = Spíše využívat baterii pro Spot."
          />
        }
        opts={{ style: 'percent', maximumFractionDigits: 0 }}
        min={20}
        max={70}
        visibility={{
          variableIds: [
            'SP_INSTALL',
            'PV_BATTERY',
            'SP_BATTERY_CONTROL_CUSTOMER',
            'SP_BATTERY_CONTROL_SERVICE',
            'SP_USER_ADVANCED_CONTROL',
            'PV_BATTERY_CONTROL',
          ],
        }}
      />
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery_max_soc"
              defaultMessage="Finální SOC baterie"
            />
          </>
        }
        variableId="SP_CHARGE_BATTERY_FINAL_SOC_MAX"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery_max_soc.subtitle"
            defaultMessage="Maximální nabití baterie při nabíjení ze sítě"
          />
        }
        opts={{ style: 'percent', maximumFractionDigits: 0 }}
        min={20}
        max={100}
        visibility={{
          variableIds: [
            'SP_INSTALL',
            'PV_BATTERY',
            'SP_BATTERY_CONTROL_CUSTOMER',
            'SP_BATTERY_CONTROL_SERVICE',
            'PV_BATTERY_CONTROL',
          ],
        }}
      />
      <ValueBox
        type="row"
        title={
          <>
            <FormattedMessage
              id="settings.spot.min_difference_price_charge_from_grid"
              defaultMessage="Minimální rozdíl ceny na spotu pro nabíjení baterie ze sítě"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.min_difference_price_charge_from_grid"
                  defaultMessage="Minimální rozdíl ceny na spotu pro nabíjení baterie ze sítě"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.min_difference_price_charge_from_grid.help"
                  defaultMessage="Tímto parametrem je možné řídit nabíjení baterie ze spotu při nízkém rozdílu mezi nejnižší a nejvyšší cenou. Pokud je parametr 2 Kč a rozdíl mezi nejvyšší cenou (3 Kč) a nejnižší cenou (1 Kč) spotu je nižší, tak se v tento den nabíjení baterie ze sítě nenaplánuje. Tento parametr je možné editovat jen v servisním menu."
                />
              }
            />
          </>
        }
        value={
          <FormattedValue
            variableId="SP_MIN_SPOT_DIFFERENCE_PRICE"
            opts={{ style: 'currency' }}
          />
        }
        visibility={{
          variableIds: [
            'SP_INSTALL',
            'PV_BATTERY',
            'SP_BATTERY_CONTROL_CUSTOMER',
            'SP_BATTERY_CONTROL_SERVICE',
            'PV_BATTERY_CONTROL',
          ],
        }}
      />
    </ParentPaper>
  );
};
